import { createSelector } from 'selectors'

import { constant } from './feedback-messenger-window.constant'

const getFeedbackMessengerWindow = () => createSelector<HTMLElement>({ selector: constant.selector.target })
const getFeedbackMessengerWindowSubjectInput = () =>
	createSelector<HTMLInputElement>({ selector: constant.selector.subjectInputTarget })

export const feedbackMessengerWindowSelector = {
	getFeedbackMessengerWindow,
	getFeedbackMessengerWindowSubjectInput,
}
